import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useMe } from '../api/hooks'
import { FullPageSpinner } from '../layout/FullPageSpinner'

export function RequireAuth() {
  const me = useMe()
  const { pathname } = useLocation()
  if (me.isPending) return <FullPageSpinner />
  if (!me.data) return <Navigate to={pathname.startsWith('/admin') ? '/admin/login' : '/login'} replace />
  // Forced first-login setup: no other page is reachable (the server refuses its API too), and /setup is pointless once done.
  if (me.data.setupRequired && pathname !== '/setup') return <Navigate to="/setup" replace />
  if (!me.data.setupRequired && pathname === '/setup') return <Navigate to="/" replace />
  return <Outlet />
}
